import React, {Component} from 'react';

const ApplicationContext = React.createContext();

export class ApplicationContextProvider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            map_enabled: false,                             // the whole app is by default disabled
        };

        this.toggleMap = this.toggleMap.bind(this);
    }

    componentDidMount() {

        /**************************************************************************************************************
         * Mutation observer config
         **************************************************************************************************************/
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        const element = document.querySelector('#map-root');
        let myThis = this;

        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                /**************************************************************************************************************
                 * Open / close calender trigger
                 **************************************************************************************************************/
                if (mutation.type === "attributes" && mutation.attributeName === "data-status") {
                    const status = document.getElementById('map-root').getAttribute('data-status');
                    myThis.setState({map_enabled: status === "enabled"});
                }
            });
        });

        observer.observe(element, {
            attributes: true //configure it to listen to attribute changes
        });

    }

    toggleMap = () => {
        // Caution! This is tricky: Enabling/disabling of the map is controlled by a data attribute of the map,
        // The application state is being managed by mutation observer, so in this case no direct state manipulation
        if (this.state.map_enabled) {
            // remove "enabled" status from map root div
            document.getElementById('map-root').setAttribute('data-status', '');
        } else {
            document.getElementById('map-root').setAttribute('data-status', 'enabled');
        }
    };

    render() {
        const {children} = this.props;

        return (
            <ApplicationContext.Provider
                value={{
                    map_enabled: this.state.map_enabled,
                    toggleMap: this.toggleMap
                }}
            >
                {children}
            </ApplicationContext.Provider>
        );
    }
}

export const ApplicationContextConsumer = ApplicationContext.Consumer;